import { Link } from "react-router-dom";
import { useSeo } from "../lib/seo";

export default function NotFound() {
  useSeo({ title: "Halaman tidak ditemukan — Heri Sensei", description: "Halaman yang Anda cari tidak tersedia.", path: "/404" });
  return (
    <div data-testid="not-found-page" className="max-w-[720px] mx-auto px-4 sm:px-8 py-24 md:py-32 text-center">
      <span className="w-3 h-3 rounded-full bg-enji inline-block mb-8" aria-hidden="true" />
      <p className="text-xs uppercase tracking-[0.22em] font-semibold text-enji">Kesalahan 404</p>
      <h1 className="font-serif text-4xl sm:text-5xl tracking-tight mt-4 text-ink">Halaman tidak ditemukan</h1>
      <p className="text-sub mt-5 leading-relaxed">
        Tautan mungkin sudah berubah atau tulisan telah dipindahkan. Mari kembali ke jalur yang benar.
      </p>
      <div className="flex flex-wrap gap-3 justify-center mt-10">
        <Link to="/tulisan" data-testid="not-found-to-articles" className="btn-primary">Jelajahi Tulisan</Link>
        <Link to="/" data-testid="not-found-to-home" className="btn-ghost">Kembali ke Beranda</Link>
      </div>
    </div>
  );
}

